export const offerFeatures = {
  GO_GREEN: "GO_GREEN",
};
